export default {
  utility: {
    id: '',
    name: '',
    plan: {
      name: 'Free Use',
      slug: 'free' ,
    }
  },
  utilityMeta: {
    id: '',
    code: '',
    name: '',
    state: '',
    municipality: '',
    zone: '',
    displayBrokerFee: 0,
  },
  facilityType: {},
  facilityCheckboxSelections: {},
  facilityProfileName: '',
  customFacilityProfileCategory: {},
  customFacilityProfile: {},
  enterCustomFacilityProfileOnPeakUsageAsPercentage: false,
  setCustomFacilityProfileUiRepeatMonthlyValues: true,
  userHasChangedACustomFacilityProfilOnPeakUsagePercentValue: false,
  volume: {
    amount: '',
    unit: 'usage', // 'usage' (kWh), 'total-cost ($)', or 'annual-peak (KW)'
    brokerFee: '',
    declineBrokerFee: false,
    adjustmentNotes: '',
    displayAdjustmentInNav: false,
  },
  customFacilityVolume: {},
  startMonth: '',
  termLength: [
    {
      id: 1,
      value: '',
    },
    {
      id: 2,
      value: '',
    },
    {
      id: 3,
      value: '',
    }
  ],
  primaryPricingComponent: null,
  pricingAlerts: [],
  savedPricingRequestId: '',
}
